// eslint-disable-next-line import/no-mutable-exports
let addSportradarTag = () => { /* placeholder */ };

export default ({ app, $config }) => {
	if (!process.client || !$config.sportradarClientId) {
		return;
	}
	initializeSportradarTag($config.sportradarClientId);
	addSportradarTag = () => initializeSportradarTag($config.sportradarClientId);
};


/**
 * Initialize Sportradar Tag Manager. Populates the window object with the srtmCommands array.
 * @param {string} sportradarClientId - The Sportradar Client ID
 */
export function initializeSportradarTag(sportradarClientId) {

	// Initialize Sportradar Tag Manager
	(function (a, b, c, d, e, f) {
		a[e] = a[e] || [];
		a.x = b.createElement(c);
		a.y = b.getElementsByTagName(c)[0];
		a.x.src = d + '?id=' + f;
		a.x.setAttribute('data-srtmn', e);
		a.y.parentNode.insertBefore(a.x, a.y);
	})(
		window,
		document,
		'script',
		'https://tm.ads.sportradar.com/dist/tag-manager.js',
		'srtmCommands',
		sportradarClientId
	);
}

export { addSportradarTag };

/**
 * Remove Sportradar Tag Manager. Removes the srtmCommands array from the window object and the script element from the DOM.
 */
export function removeSportradarTag() {
	// Remove Sportradar Tag Manager
	// The presence of this property is checked in the code
	window.srtmCommands = undefined;
	// Remove element from DOM
	document.querySelectorAll('script[data-srtmn="srtmCommands"]').forEach((script) => {
		script.parentNode.removeChild(script);
	});
}